import React from "react"
import { useQueryParamString } from "react-use-query-param-string"

import ListingSelect from "./ListingSelect"
import { Option } from "./Options"

interface Props {
  categoryOptions?: Option[]
  pageContext: any
}

const defaultProps = {}

export const ListingFilter: React.FC<Props> = props => {
  // query params
  const [categoryParam, setCategoryParam] = useQueryParamString("category", "")
  const [pageParam, setPageParam] = useQueryParamString("p", "")

  if (!props.categoryOptions) return null

  // hide section if no filter with more that 2 options (includes "Show all")
  const filterCount = [props.categoryOptions]
    .map(list => list && list.length > 2)
    .filter(Boolean)
  if (!filterCount.length) return null

  // events
  const handleCategoryChange = (option: Option | null) => {
    setCategoryParam(option?.value || "")
    if (pageParam) setPageParam("")
  }

  return (
    <div className="listing__filter">
      <ListingSelect
        param={categoryParam}
        options={props.categoryOptions}
        handleChange={handleCategoryChange}
        pageContext={props.pageContext}
      />
    </div>
  )
}

ListingFilter.defaultProps = defaultProps

export default ListingFilter
